import { useNavigate, useLocation } from "react-router-dom";

const links = [
  { label: "Services", to: "/services" },
  { label: "Process", hash: "#process" },
  { label: "Contact", hash: "#contact" },
];

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handle = (l) => {
    if (l.to) {
      navigate(l.to);
      window.scrollTo({ top: 0 });
      return;
    }
    if (location.pathname !== "/") {
      navigate("/" + l.hash);
      return;
    }
    const el = document.querySelector(l.hash);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="site-footer" className="bg-[#14213D] text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-7">
            <img src="/pikosky-logo.png" alt="Pikosky Partners" className="h-9 w-auto mb-6 brightness-0 invert" />
            <p className="text-[#AEB6CE] max-w-md leading-relaxed">
              Bookkeeping and taxation services built around accurate records and dependable, on-time support for American businesses.
            </p>
          </div>
          <div className="md:col-span-5 md:justify-self-end flex gap-8">
            {links.map((l) => (
              <button
                key={l.label}
                data-testid={`footer-nav-${l.label.toLowerCase()}`}
                onClick={() => handle(l)}
                className="label-tech !text-white hover:!text-[#8B93B8] transition-colors"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
